<template>
  <div class="layout">
    <navigation v-show="!hideHeaderAndFooter" />
    <app-main :style="{ marginTop: hideHeaderAndFooter ? '0' : '110px' }" />
    <page-footer v-show="!hideHeaderAndFooter" />
  </div>
</template>

<script>
import { navigation, appMain, pageFooter } from "./components";
export default {
  name: "Layout",
  components: {
    navigation,
    appMain,
    pageFooter,
  },
  data() {
    return {
      hideHeaderAndFooter: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    const toRouteName = to.name;
    next((vm) => {
      // 通过 `vm` 访问组件实例
      if (toRouteName == "user-login" || toRouteName == "resetPassword") {
        vm.hideHeaderAndFooter = true;
      } else {
        vm.hideHeaderAndFooter = false;
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const toRouteName = to.name;
    if (toRouteName == "user-login" || toRouteName == "resetPassword") {
      this.hideHeaderAndFooter = true;
    } else {
      this.hideHeaderAndFooter = false;
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.layout {
  font-size: $default-font-size;
}
</style>
